/**
 * 客户接口统一管理
 */

import {get, patch, post} from './http'

/**
 * 获取客户类型列表
 */
export const getcustomertypelist = () => get('goodsmanual/customer/type/list', {})

/**
 * 获取客户列表
 */
export const getcustomerlist = (params) => get('goodsmanual/customer/list', params)

/**
 * 添加客户
 * @param params
 */
export const addcustomer = (params) => post('goodsmanual/customer', params)

/**
 * 编辑客户
 * @param customerId
 * @param params
 */
export const editcustomer = (customerId, params) => patch('goodsmanual/customer/' + customerId, params)


/**
 * 获取客户详情
 * @param customerId
 */
export const getcustomerdetail = (customerId) => get('goodsmanual/customer/' + customerId, {})


/**
 * 批量删除客户
 * @param params
 */
export const delecustomers = (params) => patch('goodsmanual/customer', params)


/**
 * 添加客户作物
 * @param params
 */
export const addcustomercrop = (params) => post('goodsmanual/customer/crop', params)


/**
 * 编辑客户作物
 * @param relationId
 * @param params
 */
export const editcustomercrop = (relationId, params) => patch('goodsmanual/customer/crop/' + relationId, params)


/**
 * 获取客户作物列表
 * @param params
 */
export const getcustomercroplist = (params) => get('goodsmanual/customer/crop/list', params)

/**
 * 获取客户作物详情
 * @param relationId
 */
export const getcustomercropdetail = (relationId, params) => get('goodsmanual/customer/crop/' + relationId, params)


/**
 * 批量删除客户作物
 * @param params
 */
export const delcustomercrops = (params) => patch('goodsmanual/customer/crop/batch', params)
